import { render, staticRenderFns } from "./ContentModulesEditTiles.vue?vue&type=template&id=3b1cb0ab&scoped=true&"
import script from "./ContentModulesEditTiles.vue?vue&type=script&lang=js&"
export * from "./ContentModulesEditTiles.vue?vue&type=script&lang=js&"
import style0 from "./ContentModulesEditTiles.vue?vue&type=style&index=0&id=3b1cb0ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1cb0ab",
  null
  
)

export default component.exports